import React from 'react';

const TILE_WIDTH = 30;
const TILE_HEIGHT = 20;

export default function MapPatternDefs({ optionA, optionB }) {
  const patterns = [
    { id: 'pattern-option-a', src: optionA?.image, fallbackColor: optionA?.color ?? '#334155' },
    { id: 'pattern-option-b', src: optionB?.image, fallbackColor: optionB?.color ?? '#334155' },
  ];

  return (
    <defs>
      {patterns.map(({ id, src, fallbackColor }) =>
        src ? (
          <pattern
            key={id}
            id={id}
            patternUnits="userSpaceOnUse"
            width={TILE_WIDTH}
            height={TILE_HEIGHT}
          >
            <image
              href={src}
              crossOrigin="anonymous"
              width={TILE_WIDTH}
              height={TILE_HEIGHT}
              preserveAspectRatio="xMidYMid meet"
            />
          </pattern>
        ) : (
          <pattern
            key={id}
            id={id}
            patternUnits="userSpaceOnUse"
            width={TILE_WIDTH}
            height={TILE_HEIGHT}
          >
            <rect width={TILE_WIDTH} height={TILE_HEIGHT} fill={fallbackColor} />
          </pattern>
        )
      )}
    </defs>
  );
}
